<template>
  <div
    class="video_container relative w-full bg-black group select-none h-full"
  >
    <!--
      RELOAD SVG
    -->

    <svg
      class="m-auto absolute animate-spin opacity-30 w-[76px]"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 95.979 96"
      style="
        fill: #454545;
        filter: drop-shadow(0px 0px 15px rgb(255 255 255 / 0.6));
        top: calc(50% - 38px);
        left: calc(50% - 38px);
      "
    >
      <path
        d="M2,50A48,48,0,0,1,16.07,16.07L5.61,5.61A2.11,2.11,0,0,1,7.1,2H35a3,3,0,0,1,3,3V32.9a2.11,2.11,0,0,1-3.61,1.49l-9.84-9.84A36,36,0,0,0,50,86V98A48.05,48.05,0,0,1,2,50ZM50,2V14A36,36,0,0,1,75.45,75.45l-9.74-9.74A2.17,2.17,0,0,0,62,67.25V95a3,3,0,0,0,3,3H92.75a2.17,2.17,0,0,0,1.54-3.71L83.93,83.93A48,48,0,0,0,50,2Z"
        transform="translate(-2 -2)"
      />
    </svg>

    <!--
      VIDEO CONTAINER
    -->

    <div class="absolute w-full h-full">
      <video
        ref="video_container"
        class="w-full h-full"
        preload="none"
        controlslist="noremoteplayback nodownload"
        autoplay
        playsinline
        muted
      ></video>

      <message
        class="absolute resize text-center w-full text-xs"
        style="top: calc(50% + 50px)"
      >
        <p ref="message_container"></p>
        <p class="mt-1" v-if="!video.publish && !video.isWebcam">
          {{
            $e(
              "La vidéo ne semble pas publiée ; vérifiez si l'appareil actif ; si un autre flux est actif, changer de caméra, ou rafrachissez le flux."
            )
          }}
        </p>
      </message>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";

import Camera from "@/partials/Video/Camera/Camera.vue";
import Setting from "@/partials/Video/Camera/Setting.vue";

export default {
  name: "Video",

  props: {
    config: Object,
    video: Object,
  },

  components: {
    Camera,
    Setting,
  },

  setup() {
    return {
      video_container: ref(null),
      message_container: ref(null),
      webrtcPlayer: ref(null),
      // ----------------
      hide: ref(false),
      btnHide: ref(false),
    };
  },

  mounted() {
    this.close();

    this.webrtcPlayer = new WebRTCStreamer(
      this.video_container,
      this.message_container,
      this.video.url,
      this
    );

    this.webrtcPlayer.init();
  },

  beforeUnmount() {
    this.close();
  },

  methods: {
    close() {
      this?.webrtcPlayer?.pc?.close();
      clearTimeout(this?.webrtcPlayer?.restartTimeout);
    },

    closeVideo() {
      this.config.methods.CloseVideo(this.video, () => {
        this.close();
      });
    },

    reload() {
      this.video.relaod = true;
      this.config.methods.ReloadVideo(this.video);
    },

    openPopup() {
      this.config.methods.OpenPopup(this.config, this.video);
    },
  },

  computed: {},
};
</script>
